<template>
  <div>
    <!-- <base-attachment-item :attachment="attachmentUrl" :discard-visible="false">
    </base-attachment-item> -->
    <!-- {{attachment}} -->
    <base-attachment-viewer
      class="ml-3 mb-3"
      :attachment="attachment"
      :discard-visible="isInputsEnabled"
      @discard="fileRemove"
    ></base-attachment-viewer>
  </div>
</template>

<script>
// import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";
export default {
  components: {
    BaseAttachmentViewer,
  },
  props: {
    attachment: Object,
  },
  data: function () {
    return {
      attachmentUrl: "",
    };
  },
  created: function () {
    this.loadImage();
  },
  computed: {},
  methods: {
    async loadImage() {
      this.attachmentUrl = "";
      if (!this.attachment) return;
      this.$apiChecklist
        .request({
          //url: `${this.$store.state.urlTracking}/v1/cargo/attachment/${this.model.cargoId}/6`,
          url: `/v1/pendencies/comment/attachment/${this.attachment.id}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          this.attachmentUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
    },
  },
};
</script>
